import { render, staticRenderFns } from "./TurnStileVue2.vue?vue&type=template&id=8d69137c&scoped=true&lang=html&"
import script from "./TurnStileVue2.vue?vue&type=script&lang=js&"
export * from "./TurnStileVue2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d69137c",
  null
  
)

export default component.exports